/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Nav_LotsInputs */

const vi_sl_nav_lots = /** @type {(inputs: Sl_Nav_LotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách lô`)
};

/**

* @param {Sl_Nav_LotsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_nav_lots = /** @type {((inputs?: Sl_Nav_LotsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Nav_LotsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_nav_lots(inputs)
});